export default __webpack_public_path__ + "static/media/profile.edb522bd.svg";